import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  campaigns: (state) => {
    return state.items
  },
  getCampaignById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  },
  getById: (state) => (id) => {
    return state.items.find(item => (item.id === id))
  }
}

// actions
const actions = {

  loadCampaign ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']
    return HTTP
      .setInstance(sitekey)
      .campaign.getAll()
      .then((campaigns) => {
        dispatch('campaigns/resetCampaigns', null, { root: true })
        commit('ADD_CAMPAIGN_ITEMS', { items: campaigns })
        return campaigns
      })
  },

  resetCampaigns ({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('RESET_CAMPAIGN_ITEMS')
      resolve()
    })
  },

  addCampaign ({ commit, rootGetters }, { campaign }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .campaign.create(campaign)
      .then((campaign) => {
        commit('ADD_CAMPAIGN_ITEM', { item: campaign })
        return campaign
      })
  },
  updateCampaign ({ commit, rootGetters }, { campaign }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .campaign.update(campaign)
      .then((campaign) => {
        commit('UPDATE_CAMPAIGN_ITEM', { item: campaign })
        return campaign
      })
  },
  removeCampaign ({ commit, rootGetters }, { campaign }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .campaign.delete(campaign)
      .then((campaigns) => {
        commit('REMOVE_CAMPAIGN_ITEM', { item: campaign })
      })
  }
}

// mutations
const mutations = {
  ADD_CAMPAIGN_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_CAMPAIGN_ITEMS: (state) => {
    state.items = []
  },

  ADD_CAMPAIGN_ITEM: (state, { item }) => {
    state.items.push(item)
  },

  UPDATE_CAMPAIGN_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
      }
    }
  },
  REMOVE_CAMPAIGN_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/campaigns.js